export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_5-8dbfe97090d10924253d72aa1fbb1d0a.jpg";